module.exports = __webpack_public_path__ + "img/37_97.c402027a.png";